import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslationPipe} from './pipes/translation.pipe';
import {RouterModule} from '@angular/router';
import {TooltipDirective} from './directives/tooltip.directive';
import {CountdownModule} from 'ngx-countdown';
import {TagPipe} from './pipes/tag.pipe';
import {SelectAccountComponent} from './components/select-account/select-account.component';
import {GridsterModule} from 'angular-gridster2';
import {ByPassSecurityPipe} from './pipes/by-pass-security.pipe';
import {VenueSectionFilterPipe} from './pipes/venue-section-filter.pipe';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {InputColorPickerComponent} from './components/form/input-color-picker/input-color-picker.component';
import {InputComponent} from './components/form/input/input.component';
import {InputCurrencyComponent} from './components/form/input-currency/input-currency.component';
import {InputPhoneNumberComponent} from './components/form/input-phone-number/input-phone-number.component';
import {InputTranslationComponent} from './components/form/input-translation/input-translation.component';
import {SelectComponent} from './components/form/select/select.component';
import {CheckboxComponent} from './components/form/checkbox/checkbox.component';
import {RadioGroupComponent} from './components/form/radio-group/radio-group.component';
import {RadioComponent} from './components/form/radio/radio.component';
import {SwitchComponent} from './components/form/switch/switch.component';
import {TextSwitchComponent} from './components/form/text-switch/text-switch.component';
import {CommonModule} from '@angular/common';
import {AuthInterceptor} from './routing/auth.interceptor';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {OrderTableRowPipe} from './pipes/order-table-row.pipe';
import {SettingsComponent} from '../shared/components/settings/settings.component';
import {TimezoneComponent} from './components/form/timezone/timezone.component';
import {RangePickerComponent} from './components/form/range-picker/range-picker.component';
import {ActivityLogChangedValuesPipe} from './pipes/activity-log-changes-values.pipe';
import {TagFilterPipe} from './pipes/tag-filter.pipe';
import {DatepickerV3Component} from './components/form/datepicker-v3/datepicker-v3.component';
import {FilterPipe} from './pipes/filter.pipe';
import {JoinPipe} from './pipes/join.pipe';
import {FeatureFlagDirective} from './directives/feature-flag.directive';
import {NgxCurrencyDirective} from 'ngx-currency';
import {ComponentLibraryModule} from '../component-library/component-library.module';

@NgModule({
    declarations: [
        TranslationPipe,
        TooltipDirective,
        FeatureFlagDirective,
        TagPipe,
        SelectAccountComponent,
        ByPassSecurityPipe,
        VenueSectionFilterPipe,
        InputColorPickerComponent,
        InputComponent,
        InputCurrencyComponent,
        InputPhoneNumberComponent,
        InputTranslationComponent,
        SelectComponent,
        CheckboxComponent,
        DatepickerV3Component,
        RadioGroupComponent,
        RadioComponent,
        SwitchComponent,
        TextSwitchComponent,
        OrderTableRowPipe,
        SettingsComponent,
        TimezoneComponent,
        RangePickerComponent,
        FilterPipe,
        TagFilterPipe,
        ActivityLogChangedValuesPipe,
        JoinPipe
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        CountdownModule,
        GridsterModule,
        DragDropModule,
        ClipboardModule,
        NgxCurrencyDirective,
        ComponentLibraryModule,
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslationPipe,
        TooltipDirective,
        FeatureFlagDirective,
        TagPipe,
        CountdownModule,
        GridsterModule,
        ByPassSecurityPipe,
        VenueSectionFilterPipe,
        DragDropModule,
        ClipboardModule,
        InputColorPickerComponent,
        InputComponent,
        InputCurrencyComponent,
        InputPhoneNumberComponent,
        InputTranslationComponent,
        SelectComponent,
        CheckboxComponent,
        DatepickerV3Component,
        RadioGroupComponent,
        RadioComponent,
        SwitchComponent,
        TextSwitchComponent,
        OrderTableRowPipe,
        SettingsComponent,
        RangePickerComponent,
        TimezoneComponent,
        FilterPipe,
        TagFilterPipe,
        ActivityLogChangedValuesPipe,
        JoinPipe,
        NgxCurrencyDirective
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        TranslationPipe,
        ByPassSecurityPipe
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CoreModule {
}
